export const splitLogFieldName = (str: string) => {
  const string = str.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ');
  return [string[0].charAt(0).toUpperCase() + string[0].slice(1), string.slice(1).join(' ')];
};
